export const Selectors = {
    fbFeedSlider: '.fbDetailedListView',
};
